export const headingVariants = ['heading', 'display'] as const
export type HeadingVariant = (typeof headingVariants)[number]

export const headingSizes = [
  '3xl',
  '2xl',
  'xl',
  'lg',
  'md',
  'sm',
  'xs',
  '2xs',
  '3xs',
  '4xs',
] as const
export type HeadingSize = (typeof headingSizes)[number]

export const displaySizes = ['2xl', 'md', 'sm'] as const
export type DisplaySize = (typeof displaySizes)[number]

export type HeadingAs = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

export type HeadingArgs = {
  variant?: HeadingVariant
  size?: HeadingSize | DisplaySize
  italic?: boolean
  as?: HeadingAs
}
